import imgLoad from './imgLoad';
/** *
 * 作用：把dom节点上的图片替换成base64 or object Url 形式方便html2canvas 转换解决跨域问题
 * 用法：<div v-img-load="dataIsReady" @error="imgLoadError" :tryCount="3" @load="imgLoad">....</div>
 * 参数：dataIsReady：数据是否ready  error 图片加载失败错误回调  load: 图片替换完成回调
 * 备注：另外还支持图片压缩：可以在img 标签上配置压缩参数 例如：
 * <img crossorigin='anonymous'
 * :src="src" data-content-type="image/jpeg"
 * data-zip="0.8" alt="" class="img">
 */

imgLoad.install = function install(Vue) {
  Vue.directive('imgLoad', imgLoad);
};

export default imgLoad;